import { render, staticRenderFns } from "./account-activation.vue?vue&type=template&id=17baa6a4&"
import script from "./account-activation.vue?vue&type=script&lang=js&"
export * from "./account-activation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports